import { Box, Switch, TextField } from "@mui/material";
import { Create } from "@refinedev/mui";
import { useForm } from "@refinedev/react-hook-form";
import { useState } from "react";

export const ProdCategoriesCreate = () => {
  const {
    saveButtonProps,
    refineCore: { formLoading },
    register,
    formState: { errors },
  } = useForm();

  const [isWarriorPro, setIsWarriorPro] = useState(false);
  const [simAccess, setSimAccess] = useState(false);
  const [simBetaAccess, setSimBetaAccess] = useState(false);

  return (
    <Create isLoading={formLoading} saveButtonProps={saveButtonProps}>
      <Box
        component="form"
        sx={{ display: "flex", flexDirection: "column" }}
        autoComplete="off"
      >
        <TextField
          {...register("crmId", {
            required: "This field is required",
          })}
          error={!!(errors as any)?.crmId}
          helperText={(errors as any)?.crmId?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="CrmId"
          name="crmId"
        />
        <TextField
          {...register("name", {
            required: "This field is required",
          })}
          error={!!(errors as any)?.name}
          helperText={(errors as any)?.name?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Name"
          name="name"
        />
        <TextField
          {...register("description", {
            required: "This field is required",
          })}
          error={!!(errors as any)?.description}
          helperText={(errors as any)?.description?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Description"
          name="description"
        />
        <label style={{ marginTop: 10 }}>
          Is Warrior Pro
          <Switch
            {...register("isWarriorPro", {})}
            checked={isWarriorPro}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setIsWarriorPro(event.target.checked as any);
            }}
          />
        </label>
        <label style={{ marginTop: 10 }}>
          Sim Access
          <Switch
            {...register("simAccess", {})}
            checked={simAccess}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setSimAccess(event.target.checked as any);
            }}
          />
        </label>
        <label style={{ marginTop: 10 }}>
          Sim Beta Access
          <Switch
            {...register("simBetaAccess", {})}
            checked={simBetaAccess}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setSimBetaAccess(event.target.checked as any);
            }}
          />
        </label>
      </Box>
    </Create>
  );
};
